var _defs, _g, _text, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.21 358.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Frutiger-Bold, Frutiger;\n        font-weight: 700;\n      }\n\n      .cls-2 {\n        font-size: 40px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #0072bc;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-6 {\n        fill: #231f20;\n        font-size: 60px;\n      }\n\n      .cls-7 {\n        letter-spacing: -.09em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 270.06,
    y: 87.81,
    width: 203.28,
    height: 78.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M470.88,94.98l-4.44,13.63c-3.55-1.66-8.38-3.13-15.17-3.13-7.29,0-13.21,1.07-13.21,6.57,0,9.7,26.71,6.08,26.71,26.87,0,18.92-17.65,23.83-33.61,23.83-7.1,0-15.28-1.68-21.29-3.54l4.34-13.92c3.64,2.36,10.94,3.93,16.95,3.93s14.68-1.08,14.68-8.14c0-10.99-26.71-6.87-26.71-26.17,0-17.66,15.58-22.95,30.66-22.95,8.48,0,16.46.89,21.09,3.04M417.95,93.11l-14.29,68.45h-18.42l6.11-29.32h-21.79l-6.11,29.32h-18.42l14.29-68.45h18.42l-5.41,26.19h21.78l5.42-26.19h18.42ZM352.52,93.11l-14.58,68.45h-22.88l-14.38-47.36h-.19l-9.57,47.36h-17.35l14.7-68.45h22.96l14.1,47.46h.19l9.66-47.46h17.35ZM478.79,84.91h-211.18v85.04h211.18v-85.04Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(62.1 237.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "North Cumbria ")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.41,
    y: 61
  }, "Integrated Ca"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 361.05,
    y: 61
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 383.32,
    y: 61
  }, "e")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.02,
    y: 111
  }, "NHS Foundation "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 324.79,
    y: 111
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 343.37,
    y: 111
  }, "rust")))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 478.79,
    width: 88.41,
    height: 85.04
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company_logo.0db40e22fdb946bbde28756793a73385.svg";
export { ForwardRef as ReactComponent };